// Module
var code = "<section class=\"cr-places-module\"> <cr-title-bar label=\"Places\" icon-class=\"icon-cr-marker\"> </cr-title-bar> <cr-tabs sticky-index=\"900\" data-global-qa-id=\"manage-tabs\"> <cr-tab label=\"PLACES\" route-id=\"list\"> <cr-places-list></cr-places-list> </cr-tab> </cr-tabs> </section> ";
// Exports
export default code;